import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'

import { Layout } from './Layout'
import { ApiKeys } from './pages/ApiKeys'
import { Audit } from './pages/Audit'
import { Crawl } from './pages/Crawl'
import { DashboardPage } from './pages/DashboardPage'
import { Dashboards } from './pages/Dashboards'
import { ReportPage, Reports } from './pages/Reports'
import { BucketDetailPage } from './pages/BucketDetail'
import { EndpointDetailPage } from './pages/EndpointDetail'
import { EndpointNewPage } from './pages/EndpointNew'
import { InvitePage, LoginPage } from './pages/Login'
import { OrganisationPage } from './pages/Organisation'
import { Extraction, ExtractionEditor } from './pages/Extraction'
import { Integrations } from './pages/Integrations'
import { Endpoints } from './pages/Endpoints'
import { Buckets } from './pages/Buckets'
import { Forms } from './pages/Forms'
import { Mapping } from './pages/Mapping'
import { Blocklist } from './pages/Blocklist'
import { MCPServers } from './pages/MCPServers'
import { Placeholder } from './pages/Placeholder'
import { PublicPages } from './pages/PublicPages'
import { RunDetailPage } from './pages/RunDetail'
import { Runs } from './pages/Runs'
import { SourceDetailPage } from './pages/SourceDetail'
import { Sources } from './pages/Sources'
import './styles.css'

ModuleRegistry.registerModules([AllCommunityModule])

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 10_000, retry: 1, refetchOnWindowFocus: true } },
})

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/invite', element: <InvitePage /> },
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Sources /> },
      { path: 'sources/:slug', element: <SourceDetailPage /> },
      { path: 'runs', element: <Runs /> },
      { path: 'runs/:id', element: <RunDetailPage /> },
      { path: 'buckets', element: <Buckets /> },
      { path: 'buckets/:slug', element: <BucketDetailPage /> },
      { path: 'extraction', element: <Extraction /> },
      { path: 'extraction/:source', element: <ExtractionEditor /> },
      { path: 'integrations', element: <Integrations /> },
      { path: 'mapping', element: <Mapping /> },
      { path: 'endpoints', element: <Endpoints /> },
      { path: 'endpoints/new', element: <EndpointNewPage /> },
      { path: 'endpoints/:slug', element: <EndpointDetailPage /> },
      { path: 'api-keys', element: <ApiKeys /> },
      { path: 'pages', element: <PublicPages /> },
      { path: 'dashboards', element: <Dashboards /> },
      { path: 'dashboards/:slug', element: <DashboardPage /> },
      { path: 'reports', element: <Reports /> },
      { path: 'reports/:slug', element: <ReportPage /> },
      { path: 'crawl', element: <Crawl /> },
      { path: 'blocklist', element: <Blocklist /> },
      { path: 'mcp-servers', element: <MCPServers /> },
      { path: 'forms', element: <Forms /> },
      { path: 'audit', element: <Audit /> },
      { path: 'org', element: <OrganisationPage /> },
      { path: '*', element: <Placeholder title="Not found" /> },
    ],
  },
])

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
